import { Card, CardContent } from "@/components/ui/card";
import { AlertItem } from "@/types/dashboard";
import { Bell, AlertTriangle, CheckCircle, Info, XCircle, PartyPopper } from "lucide-react";

interface AlertsCardProps {
  data: AlertItem[];
}

export function AlertsCard({ data }: AlertsCardProps) {
  const getAlertStyles = (type: AlertItem["type"]) => {
    switch (type) {
      case "success":
        return {
          bg: "bg-green-500/20",
          icon: <CheckCircle className="h-4 w-4 text-green-300" />,
        };
      case "warning":
        return {
          bg: "bg-yellow-500/20",
          icon: <AlertTriangle className="h-4 w-4 text-yellow-300" />,
        };
      case "danger":
        return {
          bg: "bg-red-500/20",
          icon: <XCircle className="h-4 w-4 text-red-300" />,
        };
      case "info":
        return {
          bg: "bg-blue-500/20",
          icon: <Info className="h-4 w-4 text-blue-300" />,
        };
    }
  };

  return (
    <Card className="h-full border-0 shadow-lg bg-gradient-to-br from-slate-600 via-slate-700 to-gray-800 text-white">
      <CardContent className="p-5">
        <div className="flex items-center gap-2 mb-4">
          <div className="p-2 bg-white/20 backdrop-blur rounded-lg">
            <Bell className="h-4 w-4" />
          </div>
          <span className="font-medium">Alertas</span>
          {data.length > 0 && (
            <span className="ml-auto px-2 py-0.5 text-xs font-bold bg-red-500 rounded-full">
              {data.length}
            </span>
          )}
        </div>

        {data.length > 0 ? (
          <div className="space-y-2 max-h-[250px] overflow-y-auto">
            {data.map((alert, index) => {
              const styles = getAlertStyles(alert.type);
              return (
                <div
                  key={index}
                  className={`p-3 rounded-xl ${styles.bg} backdrop-blur`}
                >
                  <div className="flex items-start gap-2">
                    {styles.icon}
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-white">
                        {alert.title}
                      </p>
                      <p className="text-xs text-slate-300 mt-0.5 leading-relaxed">
                        {alert.message}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="text-center py-6">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-green-500/20 rounded-full mb-3">
              <PartyPopper className="h-6 w-6 text-green-300" />
            </div>
            <p className="text-sm font-medium text-white">Tudo certo!</p>
            <p className="text-xs text-slate-400 mt-1">Nenhum alerta</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
